import { fetchDelete, fetchGet, fetchPost, fetchPut } from './fetch';

const API_URL = `/api/v1/organization/secret_key`;

export interface SecretDto {
  created_at: string;
  id: string;
  metadata: any;
  name: string;
  secret_key: string;
}

interface GetSecretKeyResponse {
  data: {
    keys: SecretDto[];
  };
}

export const getSecretKey = async (): Promise<GetSecretKeyResponse> => {
  const url = `${API_URL}`;
  return fetchGet<GetSecretKeyResponse>(url);
};

interface CreateSecretKeyRequest {
  name: string;
}

export const createSecretKey = async (req: CreateSecretKeyRequest): Promise<any> => {
  const url = `${API_URL}`;
  return fetchPost<CreateSecretKeyRequest, any>(url, req);
};

interface EditSecretKeyRequest {
  name: string;
  id: string;
}

export const editSecretKey = async (req: EditSecretKeyRequest): Promise<any> => {
  const url = `${API_URL}`;
  return fetchPut<EditSecretKeyRequest, any>(url, req);
};
interface DeleteSecretKeyRequest {
  id: string;
}

export const deleteSecretKey = async (req: DeleteSecretKeyRequest): Promise<any> => {
  const url = `${API_URL}`;
  return fetchDelete<DeleteSecretKeyRequest, any>(url, req);
};
